import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	div: {
		paddingLeft: '16px',
		paddingRight: '16px',
	},
	box: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		paddingTop: useTheme().spacing(1),
	},
	boxContainer: {
		alignItems: 'center',
		borderRadius: useTheme().spacing(1),
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '10px',
	},
	navBox: {
		flexGrow: 1,
		paddingTop: useTheme().spacing(1),
		paddingBottom: useTheme().spacing(1),
	},
	listStack: {
		listStyle: 'none',
		padding: 0,
		margin: 0,
	},
	buttonBase: {
		alignItems: 'center',
		borderRadius: useTheme().spacing(1),
		display: 'flex',
		justifyContent: 'flex-start',
		paddingTop: '6px',
		paddingBottom: '6px',
		textAlign: 'left',
		width: '100%',
		'&:hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.16)',
		},
	},
	iconBox: {
		alignItems: 'center',
		color: 'neutral.400',
		display: 'inline-flex',
		justifyContent: 'center',
		paddingLeft: useTheme().spacing(1),
		paddingRight: useTheme().spacing(1),
		marginRight: useTheme().spacing(0.5),
	},
	itemTitle: {
		color: 'neutral.400',
		flexGrow: 1,
		fontFamily: useTheme().typography.fontFamily,
		fontSize: 14,
		fontWeight: 600,
		lineHeight: '24px',
		whiteSpace: 'nowrap',
	},
	papperProps: {
		backgroundColor: 'rgba(34, 42, 69, 0.96)',
		color: useTheme().palette.common.white,
		width: 260,
		transition: 'width 250ms ease',
	},
	smPaperProps: {
		backgroundColor: 'rgba(34, 42, 69, 0.96)',
		color: useTheme().palette.common.white,
		transition: 'width 250ms ease',
		width: 260,
		zIndex: useTheme().zIndex.appBar + 100,
	},
	logoContainer: {
		height: 50,
		width: 50,
		objectFit: 'contain',
		borderRadius: 10,
	},
	headingContainer: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	Title: {
		marginLeft: 5,
	},
}));

export default styles;
